import { render, staticRenderFns } from "./FiltrosMovimentacao.vue?vue&type=template&id=0fb3405f&"
import script from "./FiltrosMovimentacao.vue?vue&type=script&lang=js&"
export * from "./FiltrosMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports